var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isReady
    ? _c("ChatbotDashboard", {
        attrs: {
          board: _vm.board(_vm.storyId),
          storyId: _vm.storyId,
          storyVersion: _vm.storyVersion,
          "story-title": _vm.$_.get(_vm.getStoryById(_vm.storyId), "title"),
        },
      })
    : _c("CbDashboardProgressBar", { attrs: { isReady: _vm.isReady } })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }